import low_Eb from "./all_chromatic_scales/trombone_chr_scale/bone_low_Eb.mp3";
import low_E from "./all_chromatic_scales/trombone_chr_scale/bone_low_E.mp3";
import low_F from "./all_chromatic_scales/trombone_chr_scale/bone_low_F.mp3";
import low_Gb from "./all_chromatic_scales/trombone_chr_scale/bone_low_Gb.mp3";
import low_G from "./all_chromatic_scales/trombone_chr_scale/bone_low_G.mp3";
import low_Ab from "./all_chromatic_scales/trombone_chr_scale/bone_low_Ab.mp3";
import low_A from "./all_chromatic_scales/trombone_chr_scale/bone_low_A.mp3";
import low_Bb from "./all_chromatic_scales/trombone_chr_scale/bone_low_Bb.mp3";
import low_B from "./all_chromatic_scales/trombone_chr_scale/bone_low_B.mp3";
import low_C from "./all_chromatic_scales/trombone_chr_scale/bone_low_C.mp3";
import low_Db from "./all_chromatic_scales/trombone_chr_scale/bone_low_Db.mp3";
import low_D from "./all_chromatic_scales/trombone_chr_scale/bone_low_D.mp3";
import Eb from "./all_chromatic_scales/trombone_chr_scale/bone_Eb.mp3";
import E from "./all_chromatic_scales/trombone_chr_scale/bone_E.mp3";
import F from "./all_chromatic_scales/trombone_chr_scale/bone_F.mp3";
import Gb from "./all_chromatic_scales/trombone_chr_scale/bone_Gb.mp3";
import G from "./all_chromatic_scales/trombone_chr_scale/bone_G.mp3";
import Ab from "./all_chromatic_scales/trombone_chr_scale/bone_Ab.mp3";
import A from "./all_chromatic_scales/trombone_chr_scale/bone_A.mp3";
import Bb from "./all_chromatic_scales/trombone_chr_scale/bone_Bb.mp3";
import B from "./all_chromatic_scales/trombone_chr_scale/bone_B.mp3";
import C from "./all_chromatic_scales/trombone_chr_scale/bone_C.mp3";
import Db from "./all_chromatic_scales/trombone_chr_scale/bone_Db.mp3";
import D from "./all_chromatic_scales/trombone_chr_scale/bone_high_D.mp3";

//images
import low_Eb_image from "../app/images/bass-clef-notes/Low-Eb.png"
import low_E_image from "../app/images/bass-clef-notes/Low-E.png";
import low_F_image from "../app/images/bass-clef-notes/Low-F.png";
import low_Gb_image from "../app/images/bass-clef-notes/Low-Gb.png";
import low_G_image from "../app/images/bass-clef-notes/Low-G.png";
import low_Ab_image from "../app/images/bass-clef-notes/Low-Ab.png";
import low_A_image from "../app/images/bass-clef-notes/Low-A.png";
import low_Bb_image from "../app/images/bass-clef-notes/Low-Bb.png";
import low_B_image from "../app/images/bass-clef-notes/Low-B.png";
import low_C_image from "../app/images/bass-clef-notes/Low-C.png";
import low_Db_image from "../app/images/bass-clef-notes/Low-Db.png";
import low_D_image from "../app/images/bass-clef-notes/Low-D.png";
import Eb_image from "../app/images/bass-clef-notes/Eb.png";
import E_image from "../app/images/bass-clef-notes/E.png";
import F_image from "../app/images/bass-clef-notes/F.png";
import Gb_image from "../app/images/bass-clef-notes/Gb.png";
import G_image from "../app/images/bass-clef-notes/G.png";
import Ab_image from "../app/images/bass-clef-notes/Ab.png";
import A_image from "../app/images/bass-clef-notes/A.png";
import Bb_image from "../app/images/bass-clef-notes/Bb.png";
import B_image from "../app/images/bass-clef-notes/B.png";
import C_image from "../app/images/bass-clef-notes/C.png";
import Db_image from "../app/images/bass-clef-notes/Db.png";
import D_image from "../app/images/bass-clef-notes/D.png";

export const tromboneChrScale = [
  {
    index: 0,
    name: "Low Eb",
    image: low_Eb_image,
    audio_file: new Audio(low_Eb),
  },
  {
    index: 1,
    name: "Low E",
    image: low_E_image,
    audio_file: new Audio(low_E),
  },
  {
    index: 2,
    name: "Low F",
    image: low_F_image,
    audio_file: new Audio(low_F),
  },
  {
    index: 3,
    name: "Low Gb",
    image: low_Gb_image,
    audio_file: new Audio(low_Gb),
  },
  {
    index: 4,
    name: "Low G",
    image: low_G_image,
    audio_file: new Audio(low_G),
  },
  {
    index: 5,
    name: "Low Ab",
    image: low_Ab_image,
    audio_file: new Audio(low_Ab),
  },
  {
    index: 6,
    name: "Low A",
    image: low_A_image,
    audio_file: new Audio(low_A),
  },
  {
    index: 7,
    name: "Low Bb",
    image: low_Bb_image,
    audio_file: new Audio(low_Bb),
  },
  {
    index: 8,
    name: "Low B",
    image: low_B_image,
    audio_file: new Audio(low_B),
  },
  {
    index: 9,
    name: "Low C",
    image: low_C_image,
    audio_file: new Audio(low_C),
  },
  {
    index: 10,
    name: "Low Db",
    image: low_Db_image,
    audio_file: new Audio(low_Db),
  },
  {
    index: 11,
    name: "Low D",
    image: low_D_image,
    audio_file: new Audio(low_D),
  },
  {
    index: 12,
    name: "Eb",
    image: Eb_image,
    audio_file: new Audio(Eb),
  },
  {
    index: 13,
    name: "E",
    image: E_image,
    audio_file: new Audio(E),
  },
  {
    index: 14,
    name: "F",
    image: F_image,
    audio_file: new Audio(F),
  },
  {
    index: 15,
    name: "Gb",
    image: Gb_image,
    audio_file: new Audio(Gb),
  },
  {
    index: 16,
    name: "G",
    image: G_image,
    audio_file: new Audio(G),
  },
  {
    index: 17,
    name: "Ab",
    image: Ab_image,
    audio_file: new Audio(Ab),
  },
  {
    index: 18,
    name: "A",
    image: A_image,
    audio_file: new Audio(A),
  },
  {
    index: 19,
    name: "Bb",
    image: Bb_image,
    audio_file: new Audio(Bb),
  },
  {
    index: 20,
    name: "B",
    image: B_image,
    audio_file: new Audio(B),
  },
  {
    index: 21,
    name: "C",
    image: C_image,
    audio_file: new Audio(C),
  },
  {
    index: 22,
    name: "Db",
    image: Db_image,
    audio_file: new Audio(Db),
  },
  {
    index: 23,
    name: "D",
    image: D_image,
    audio_file: new Audio(D),
  },
];
